// Mirror of CssfPdfFooter.jsx: CSSF logo + address block + page number.

import { AlignmentType, Footer, ImageRun, PageNumber, Paragraph, Table, TableCell, TableRow, TextRun, VerticalAlign, WidthType } from "docx";
import { CONTENT_WIDTH, NO_CELL_BORDERS, NO_TABLE_BORDERS, para, run } from "../../shared/wordHelpers";
import { CSSF_FOOTER, FONT_VERDANA } from "../../shared/wordTheme";
import { ptToHalfPoints, pxToTwips } from "../../shared/wordUnits";

export function buildCssfFooter( { footerImage } ) {
    const logoW = pxToTwips( 70 );
    const pageW = pxToTwips( 60 );
    const textW = CONTENT_WIDTH - logoW - pageW;

    const logoChildren = footerImage
        ? [ para( new ImageRun( { data: footerImage.data, transformation: { width: 55, height: 80 } } ), { spacing: { after: 0 } } ) ]
        : [ para( [], { spacing: { after: 0 } } ) ];

    const line = ( text, bold ) => para(
        run( text, { pt: 6, bold, color: CSSF_FOOTER, font: FONT_VERDANA } ),
        { spacing: { after: 0 } }
    );

    const pageNumber = new TableCell( {
        width: { size: pageW, type: WidthType.DXA },
        borders: NO_CELL_BORDERS,
        verticalAlign: VerticalAlign.BOTTOM,
        children: [
            new Paragraph( {
                alignment: AlignmentType.RIGHT,
                children: [
                    new TextRun( {
                        children: [ PageNumber.CURRENT, " / ", PageNumber.TOTAL_PAGES ],
                        size: ptToHalfPoints( 8 ),
                        color: "000000",
                        font: FONT_VERDANA,
                    } ),
                ],
            } ),
        ],
    } );

    return new Footer( {
        children: [
            new Table( {
                width: { size: CONTENT_WIDTH, type: WidthType.DXA },
                columnWidths: [ logoW, textW, pageW ],
                borders: NO_TABLE_BORDERS,
                rows: [
                    new TableRow( {
                        children: [
                            new TableCell( { width: { size: logoW, type: WidthType.DXA }, borders: NO_CELL_BORDERS, verticalAlign: VerticalAlign.BOTTOM, children: logoChildren } ),
                            new TableCell( {
                                width: { size: textW, type: WidthType.DXA },
                                borders: NO_CELL_BORDERS,
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    line( "Commission de Surveillance du Secteur Financier", true ),
                                    line( "283, route d’Arlon – L-2991 Luxembourg – (+352) 26 25 1-1 – direction@cssf.lu – TVA LU17756005", false ),
                                    line( "www.cssf.lu", true ),
                                ],
                            } ),
                            pageNumber,
                        ],
                    } ),
                ],
            } ),
        ],
    } );
}
